import React, { FC } from 'react'
import { pageSectionMap } from '../../../constants/urlSections.constants'
import { BreadcrumbOuter } from './style'

//* Helpers
import { LocaleCodes } from '../../../constants/localization.constants'
import { GenerateBreadcrumb } from './subcomponents/generateBreadcrumb'

type Props = {
  currentPathname: string
  backgroundTheme: 'light' | 'dark' | string
  pageName: string
  className?: string
  isBlogBreadcrumb?: boolean
  pageType?: string
  locale?: string
  breadcrumb?: any
  isSecondaryBlog?: boolean
  useCase?: string
}

const Breadcrumbs: FC<Props> = ({
  currentPathname,
  backgroundTheme = 'light',
  pageName,
  className,
  isBlogBreadcrumb,
  pageType,
  locale,
  breadcrumb,
  useCase,
}) => {
  //* only allow breadcrumb translations for available locales in pageSectionMap
  //* for other locales & blogs, use the default locale (en-US)
  let entryLocale = LocaleCodes.ENGLISH.code
  if (locale && (pageSectionMap as any)[locale]) entryLocale = locale
  return (
    <>
      <BreadcrumbOuter
        className={className}
        data-cy="breadcrumbs"
        $pageType={pageType}
        $useCase={useCase}
        $breadcrumbTheme={backgroundTheme}>
        {(pageType !== 'events' || (pageType === 'events' && breadcrumb)) && ( //* don't show breadcrumbs on events page when not authored for page level and Hero component
          <GenerateBreadcrumb
            breadcrumb={breadcrumb}
            isBlogBreadcrumb={isBlogBreadcrumb || false}
            entryLocale={entryLocale}
            currentPathname={currentPathname}
            pageName={pageName}
          />
        )}
      </BreadcrumbOuter>
    </>
  )
}

export default Breadcrumbs
